export default {
    general: {
        checkMyProgress: 'Check my progress',
        getStarted: 'Get started!',
        getToKnowYourself: 'Get to know yourself',
        getToKnowYourselfBold: 'Get to know <strong>yourself</strong>',
        getToKnowYourFuture: 'Get to know your future',
        getToKnowYourFutureBold: 'Get to know your <strong>future</strong>',
        openAssessments: 'Open assessments',
        openAssessment: 'Open assessment',
        unlock: 'Unlock the tests',
        testYourself: 'Test yourself',
        takeTheFreeTests: 'Take the free tests',
        youOwnThisProduct: 'You own this product',
        startTest: 'Start test',
        startTests: 'Start tests',
        continue: 'Continue',
        showReport: 'Show report',
        showYourReports: 'Show your reports',
        showYourReport: 'Show your report',
        continueFreeTests: 'Continue the free tests',
        continueTheTest: 'Continue the test',
        estimatedTime: '~ {min} min',
    },

    landing: {
        section1: {
            title: 'Start your assessment training now',
            description01:
                'Welcome to Highered’s Aon Assessments Center, helping you along your career journey. Recruiters worldwide use assessment tests as a baseline for their recruitment processes to check your aptitude and readiness for a future career. There is a very high risk to taking an assessment without being prepared. You could end up losing your dream job because you don’t understand the questions or the methods used. So get started today!',

            freemium: {
                title: 'Free Assessment Testing',
                description:
                    'Take these tests to familiarize yourself with the testing methods of the assessments and get basic reports to identify your skills.',

                price: 'Free',
                numTests: '3 tests',
                timeEstimated: '~ 27 min',

                report: {
                    title: 'Assessment Report',
                    description:
                        'The free Aon assessments tests are a great starting point to begin your preparation for actual assessments during selection processes. Try it out today to get comfortable with the format, questions and methodology behind online assessments used in recruitment. You will receive a basic report after the completion of each assessment task. For a more detailed career assessment report consider taking the Pathfinder Assessment.',
                },
            },

            premium: {
                title: 'Pathfinder Assessment Testing',
                description:
                    'Take ownership of your career planning! Going down the wrong career path and discipline of study is extremely costly. Avoid this mistake by taking the Pathfinder Assessment and receive an in-depth career path mapping based on your strengths and potential for improvement.',

                numTests: '3-in-1 test',
                timeEstimated: '~ 60 min',

                sampleReport: '↓Download Sample Report',

                report: {
                    title: 'Pathfinder Explorer Report',
                    description:
                        'Once you finish these tests you will get a detailed report with a comprehensive overview of the five matches to jobs for which you are a great fit. These matches allow you to make an informed decision about your next career step. The summary of results will provide a snapshot of who you are, helping you to understand the strengths you can leverage and areas where you might wish to devote additional time for development. To guide your efforts, this report also includes development tips for each of the competencies described.',
                },
            },
        },

        section2: {
            title: 'How will these tests help you get hired?',
            t1: 'You will know your <strong>skills</strong>',
            t2: 'You will realize your <strong>potential</strong>',
            t3: 'You will have a clear <strong>career path</strong>',
            t4: 'You will boost your <strong>confidence</strong>',
        },

        section3: {
            title:
                'Learn about your personal strengths and career opportunities to drive your development and career progression.',
        },

        section4: {
            title: 'Get ahead of your competitors today',
            description:
                'by completing assessments used by recruiters worldwide at companies like Deloitte, Siemens, Burger King, Vodafone, or P&G.',
        },

        section5: {
            title: 'Frequently Asked Questions',
            thisPage: 'this page',
            question01: {
                q: 'What are Aon Assessments?',
                a: `Talent Assessments by Aon are globally recognized tests which help companies all over the world to identify the best candidates for a job. With the help of talent assessments recruiters can look beyond CVs, school grades, college certificates and university diplomas to find out whether a candidate is a good match.
                <br><br>
                These solutions are usually reserved <strong>for recruiters only</strong> – here, you get an <strong>exclusive</strong> opportunity to practice and get your results ahead of your job interview. Most candidates don’t get this chance, so take advantage of it!`,
            },
            question02: {
                q: 'Do I need to pay to take these assessments?',
                a: `You can take 4 of these tests for free – <i>Work-related Behavior</i>, <i>Numerical Reasoning</i>, <i>Deductive-logical Thinking</i>, and <i>Inductive-logical Reasoning</i>. These tests are measuring your skills and aptitude and are a great way to find out your strengths and weaknesses.

                <br><br>However, if you would like to have a full overview of your predispositions, gain professional insights on your best-fit career paths and take a big step towards your future success, you can also access the 3-in-1 test and get a comprehensive Candidate Report for €79. <br><br>For the extended access, just <a href={premiumLink}>click here</a> and pay by card – we are using a secure payment method.
                `,
            },
            question03: {
                q: 'Why should I take these tests?',
                a: `
                Recruiters around the world use AON Assessment Tests in their candidate selection process. By completing them ahead of time and presenting them with ready reports, you get a great opportunity to truly amaze the recruiters. How? 
                <br><br>
                First – you come prepared with part of the recruitment process already done, which will instantly make you jump ahead of other candidates.
                <br><br>
                Second – you approach your recruitment with a clear mind. You know your strengths and what the future holds for you – instant motivation and a proper confidence boost guaranteed! Recruiters will be able to tell that.`,
            },
            question04: {
                q: 'How can I prepare for these tests?',
                a:
                    'You can read all about technical requirements and how to prepare yourself for the assessments on <a href={link} target="_blank">this page</a>. There you will also find materials to help you ace it!',
            },
            question05: {
                q: 'Where else can I find these assessments?',
                a:
                    'Typically, you might be asked to complete these tests by your recruiter – other than that, you won’t find these available for you anywhere else. This is an exclusive opportunity for you to practice, find out more about yourself and about your future career.',
            },
            question06: {
                q: 'How many times can I take the tests?',
                a:
                    'You get only one take for each test. No retakes! Make sure you have comfortable conditions to take it to make the most of this opportunity. You can familiarize yourself with the test by watching instructional screencast videos and doing a practice exercise before taking the test.',
            },
            question07: {
                q: 'In what language are these tests?',
                a: `
                The default language for these tests is English, however, each of them has a variety of languages to choose from. You can check which languages are available and choose the one that suits you best before taking the test. 
                `,
            },
            question08: {
                q: 'Is there an expiration date on the extended tests once I pay for them?',
                a:
                    'Nope! After your payment is accepted, you can take the extended tests whenever you like. Take your time to prepare and start the assessments at whatever time fits you best.',
            },
        },
    },

    center: {
        header: 'Assessments by AON',

        banner: {
            title: 'Check your progress',
            subtitle: "Here's an overview of your progress in career assessments",
            moreInfo: 'More information',
            yourProgress: 'Your progress',
            quote: 'Setting goals is the first step in turning the invisible into the visible.',
        },

        list: {
            timeEstimated: 'approx. {minutes} min',

            freemium: {
                intro: `
                    This is the first step in your personal development journey! <br />
                    Take these tests to measure your strengths and get efficient reports of your
                    skills.
                `,
            },

            premium: {
                intro: `
                    This is the real deal.<br />
                    Take these tests to find out which career paths you should pursue and get a
                    comprehensive <strong>Candidate Report</strong>.
                `,
                description: `
                    Your <strong>Candidate Report</strong> will give you a comprehensive
                    overview of your results including <strong>tips</strong> on improving your
                    personal skill set, which <strong>skills</strong> you should pay attention to, the
                    best <strong>opportunities</strong> to start with, what should be your
                    <strong>next step</strong>, and more.
                `,
            },
        },

        instruments: {
            721: {
                name: 'Numerical Reasoning',
                description:
                    'How good are you with crunching numbers? This test measures your understanding of numerical information and reaching logical conclusions.',
                estimatedTime: '9',
            },

            344: {
                name: 'Deductive-logical Thinking',
                description:
                    'See how good you are with using knowledge and applying rules – this test measures your analytical and problem-solving abilities.',
                estimatedTime: '9',
            },

            383: {
                name: 'Inductive-logical Reasoning',
                description:
                    'How well can you identify rules and interrelations? Check with this test which measures your analytical and problem-solving abilities.',
                estimatedTime: '9',
            },

            390: {
                name: 'Work-related Behavior (ADEPT-15)',
                description:
                    'What type of employee personality traits do you have? Find out by taking this test which identifies your work-based personality characteristics.',
                estimatedTime: '30',
            },
            5392: {
                name: 'Working Memory',
                description:
                    'How well can you stay focused? This test measures ability to process and remember information in distracting environments.',
                estimatedTime: '15',
            },
            82013: {
                name: 'flexTest',
                description:
                    'What are your interests? This questionnaire will help determine which career paths you might want to pursue.',
                estimatedTime: '15',
            },
        },
    },

    dialog: {
        header: 'Start your Aon assessments',
        consent: `I understand that Aon is responsible for my data related to this assessment, and agree to their terms and conditions.
                I also agree that Highered can transfer my name to Aon to generate my report.`,
        startTest: 'Start test',
        consentErrorTitle: 'Consent error',
        consentErrorMessage:
            'Something went wrong while submitting your consent. Have you confirmed your email?',
    },
};
